import { render, staticRenderFns } from "./cert.vue?vue&type=template&id=b00af8a2&scoped=true&"
import script from "./cert.vue?vue&type=script&lang=js&"
export * from "./cert.vue?vue&type=script&lang=js&"
import style0 from "./cert.vue?vue&type=style&index=0&id=b00af8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00af8a2",
  null
  
)

export default component.exports